import L from 'leaflet';

export const leafletDrawLanguageConfig = () =>
    (L.drawLocal = {
        draw: {
            toolbar: {
                // #TODO: this should be reorganized where actions are nested in actions
                // ex: actions.undo  or actions.cancel
                actions: {
                    title: 'لغو طراحی',
                    text: 'لغو',
                },
                finish: {
                    title: 'تمام کردن طراحی',
                    text: 'تمام',
                },
                undo: {
                    title: 'آخرین نقطه ترسیم شده را حذف کنید',
                    text: 'نقته آخر را حذف کن',
                },
                buttons: {
                    polyline: 'خط بکشید',
                    polygon: 'چند ضلعی بکشید',
                    rectangle: 'مستطیل بکشید',
                    circle: 'دایره بکشید',
                    marker: 'نشانگر بکشید',
                    circlemarker: 'نشانگر دایره ای بکشید',
                },
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: 'برای رسم دایره کلیک کنید و بکشید',
                    },
                    radius: 'شعاع',
                },
                circlemarker: {
                    tooltip: {
                        start: 'برای قرار دادن نشانگر دایره روی نقشه کلیک کنید',
                    },
                },
                marker: {
                    tooltip: {
                        start: 'برای قرار دادن نشانگر روی نقشه کلیک کنید',
                    },
                },
                polygon: {
                    tooltip: {
                        start: 'برای شروع رسم شکل کلیک کنید',
                        cont: 'برای ادامه طراحی شکل کلیک کنید',
                        end: 'برای بستن این شکل روی نقطه اول کلیک کنید',
                    },
                },
                polyline: {
                    error: '<strong>خطا:</strong> لبه های شکل نمی توانند متقاطع شوند',
                    tooltip: {
                        start: 'برای شروع کشیدن خط کلیک کنید',
                        cont: 'برای ادامه خط کشیدن کلیک کنید',
                        end: 'برای پایان خط روی آخرین نقطه کلیک کنید',
                    },
                },
                rectangle: {
                    tooltip: {
                        start: 'برای رسم مستطیل کلیک کنید و بکشید',
                    },
                },
                simpleshape: {
                    tooltip: {
                        end: 'برای تمام کردن طراحی ماوس را رها کنید ',
                    },
                },
            },
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: 'ذخیره تغییرات',
                        text: 'ذخیره',
                    },
                    cancel: {
                        title: 'لغو ویرایش،همه تغییرات را دور می اندازد',
                        text: 'لغو',
                    },
                    clearAll: {
                        title: 'تمام لایه ها را پاک کنید',
                        text: 'همه را پاک کن',
                    },
                },
                buttons: {
                    edit: 'ویرایش لایه ها',
                    editDisabled: 'هیچ لایه ای برای ویرایش وجود ندارد',
                    remove: 'حذف لایه ها',
                    removeDisabled: 'هیچ لایه ای برای حذف وجود ندارد',
                },
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: 'دستگیره ها یا نشانگرها را برای ویرایش ویژگی ها بکشید',
                        subtext: 'برای لغو تغییرات روی لغو کلیک کنید.',
                    },
                },
                remove: {
                    tooltip: {
                        text: 'برای حذف روی یک ویژگی کلیک کنید',
                    },
                },
            },
        },
    });
